import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FaEdit, FaSave } from "react-icons/fa";
import { RiMenuAddFill } from "react-icons/ri";
import ClinicVisitScanSubtitle from "./ClinicVisitScanSubtitle";
import ClinicCheckListSubtitleForm from "./ClinicCheckListSubtitleForm";

const ClinicCheckListForm = ({ checklistItem, referesh, setReferesh }) => {
  const [title, setTitle] = useState(checklistItem.title);
  const [showEdit, setShowEdit] = useState(checklistItem.edit);

  const addSubtitle = () => {
    checklistItem.subtitles = [
      ...checklistItem.subtitles,
      {
        idx: Math.random(),
        subtitle: "",
        options: [],
      },
    ];
    setReferesh(!referesh);
  };
  useEffect(() => {
    checklistItem.title = title;
    setReferesh(!referesh);
  }, [title]);

  return (
    <div className="card border-info p-3">
      {showEdit ? (
        <div className="text-info">
          <Form.Group controlId="title">
            <Form.Control
              placeholder="Type scan title here, like: Basic Scan"
              type="text"
              onChange={(e) => setTitle(e.target.value)}
              value={title}
              isValid={title}
            ></Form.Control>
          </Form.Group>

          {checklistItem?.subtitles?.map((i) => (
            <div key={i.idx || i._id} className="mx-4">
              <hr className="border border-dark" />
              <ClinicCheckListSubtitleForm
                subtitleObject={i}
                referesh={referesh}
                setReferesh={setReferesh}
              />
            </div>
          ))}
          <Button
            variant="outline-info"
            className="btn-block my-2"
            onClick={addSubtitle}
          >
            <RiMenuAddFill /> Add Subtitle
          </Button>
        </div>
      ) : (
        <Card className="rounded-3 text-dark ">
          <Card.Header>{title}</Card.Header>
          <Card.Body>
            {/* <pre>{JSON.stringify(checklistItem.subtitles, null, 2)}</pre> */}

            {checklistItem?.subtitles?.map((st) => (
              <Row key={st.idx || st._id}>
                {!st.isHide && (
                  <Col>
                    {st.subtitle}:
                    {st.options
                      .filter((o) => !o.isHide)
                      .map((o) => o.label)
                      .join(", ")}
                  </Col>
                )}
              </Row>
            ))}
          </Card.Body>
          <Card.Footer>
            <Row className="text-right">
              <Col>
                <div onClick={() => setShowEdit(true)}>
                  <FaEdit /> Edit
                </div>
              </Col>
            </Row>
          </Card.Footer>
        </Card>
      )}
    </div>
  );
};

export default ClinicCheckListForm;
